import { useMemo } from "react"
import { useFetchAllBrandsQuery } from "../../redux/queries"
import { Brand } from "../../types"

export const useBrandMap = () => {
  const { data: allBrands = [], isLoading: isBrandsLoading } =
    useFetchAllBrandsQuery({ limit: 999 })

  const brandMap = useMemo<Record<string, Brand>>(
    () => Object.fromEntries(allBrands.map(b => [b.id, b])),
    [allBrands]
  )

  return { allBrands, brandMap, isBrandsLoading }
}
